'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  Code modifed from ReactGA (https://github.com/react-ga/react-ga) to allow for
  multiple GA trackers.
 **/

/**
 * create():
 * Creates trackers and pulls down analytics.js if it is not already in the
 * window namespace.
 * @param options {object} Fields object for creating a tracker
 */
function create(options) {
  if (window && !window.ga) {
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/
    /* eslint-disable */
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();
      a = s.createElement(o), m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    /* eslint-enable */
  }

  window.ga('create', options);
}

/**
 * ga:
 * Safe passthrough wrapper for window.ga
 */
function ga() {
  if (window && window.ga) {
    return window.ga;
  }

  return undefined;
}

function sendPageviewToTrackers(path) {
  // There may be trackers from the Core header in GA's namespace. Filter out
  // any trackers that are NOT NERF-specific.
  var trackers = window.ga.getAll().filter(function (tracker) {
    var regex = /^bcNERF/;
    var name = tracker.get('name');
    return regex.test(name);
  });

  return _lodash2.default.each(trackers, function (tracker) {
    tracker.send('pageview', path);
  });
}

/**
 * pageView():
 * Send a page view event to GA for the provided path
 * @param path {string} Path to track
 */
function pageView(path) {
  if (!window || !window.ga) {
    return false;
  }

  window.ga('set', { page: path });
  // GA may not be fully instantiated yet. Put the command in the command queue
  // if necessary
  if (!window.ga.getAll) {
    return window.ga(function () {
      sendPageviewToTrackers(path);
    });
  }

  return sendPageviewToTrackers(path);
}

/**
 * event():
 * Send an event object to GA
 * @param event {object} Event object to send to GA
 * @param sendToLibrary {boolean} send to library's tracker
 */
function event(eventObj) {
  var sendToLibrary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var trackers = ['bcNERFTracker', sendToLibrary ? 'bcNERFLibraryTracker' : null];
  if (!window || !window.ga) {
    return false;
  }

  trackers.filter(function (tracker) {
    return !!tracker;
  }).forEach(function (tracker) {
    window.ga(tracker + '.send', 'event', eventObj);
  });

  return true;
}

function getGACrossDomainNames(library) {
  var domains = [];

  if (library.gaCrossDomainEnabled) {
    if (library.gaCrossDomainNames) {
      domains = library.gaCrossDomainNames;
    }

    if (library.cmsEnabled && library.cmsUrl) {
      var parsed = new _urlParse2.default(library.cmsUrl);
      if (parsed.host) {
        domains.push(parsed.host);
      }
    }
  }

  return domains;
}

function initialize(gaTrackingId, library, currentLanguage) {
  if (gaTrackingId) {
    create({
      trackingId: gaTrackingId,
      cookieDomain: 'auto',
      name: 'bcNERFTracker'
    });

    ga()('bcNERFTracker.set', 'language', currentLanguage);
    ga()('bcNERFTracker.set', 'transport', 'beacon');
  }

  if (library && library.externalGaId) {
    create({
      trackingId: library.externalGaId,
      name: 'bcNERFLibraryTracker',
      cookieDomain: library.gaDomainName,
      allowLinker: library.gaCrossDomainEnabled
    });

    ga()('bcNERFLibraryTracker.set', 'language', currentLanguage);
    ga()('bcNERFLibraryTracker.set', 'transport', 'beacon');

    var gaAutolinkDomains = getGACrossDomainNames(library);

    if (gaAutolinkDomains.length) {
      /* Cross domain tracking */
      ga()('bcNERFLibraryTracker.require', 'linker');
      ga()('bcNERFLibraryTracker.linker:autoLink', gaAutolinkDomains);
    }
  }
}

exports.default = {
  create: create,
  ga: ga,
  pageView: pageView,
  event: event,
  getGACrossDomainNames: getGACrossDomainNames,
  initialize: initialize
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-google-analytics/lib/index.js
// module id = 231
// module chunks = 1